import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"
import { slimSelectSettings } from "../helpers/slim_select_helpers"

export default class extends Controller {
  static values = {
    createUrl: { type: String, default: "/customers/quick_create" },
    canCreate: { type: Boolean, default: false },
    // The block keeps an unknown company on the row (`text:<name>`) instead of creating a
    // Customer — see CustomReportBlockEntry#data=.
    freeText: { type: Boolean, default: false },
    // Translated by the view (custom_reports.blocks.partner_companies.add_value / use_value).
    addableText: { type: String, default: "" },
  }

  connect() {
    const canCreate = this.canCreateValue

    const config = {
      select: this.element,
      settings: slimSelectSettings({
        allowDeselect: true,
        showSearch: true,
        searchPlaceholder: canCreate ? "Suchen oder neu erstellen" : "Suchen...",
        placeholderText: this.element.dataset.placeholder || "Partnerfirma auswählen...",
      }),
      events: {
        searchFilter: (option, search) => {
          if (search.length === 0) return true
          const searchTerms = search.toLowerCase().split(" ")
          const optionText = option.text.toLowerCase()
          return searchTerms.every((term) => optionText.includes(term))
        },
      },
    }

    if (canCreate) {
      config.settings.addableText = this.addableTextValue
      config.events.addable = (value) => {
        return this.freeTextValue ? this.freeTextOption(value) : this.createPartnerCompany(value)
      }
    }

    this.slimSelect = new SlimSelect(config)
  }

  disconnect() {
    if (this.slimSelect) {
      this.slimSelect.destroy()
    }
  }

  freeTextOption(name) {
    const trimmedName = name.trim()
    if (trimmedName.length === 0) return false

    return { text: trimmedName, value: `text:${trimmedName}` }
  }

  async createPartnerCompany(name) {
    const trimmedName = name.trim()
    if (trimmedName.length === 0) return false

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(this.createUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({ name: trimmedName }),
      })

      if (!response.ok) return false

      const data = await response.json()
      return { text: data.name, value: String(data.id) }
    } catch (error) {
      console.error("Partner company creation failed:", error)
      return false
    }
  }
}
